<template>
  <div class="staff">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :documentoNumero="documentoNumero"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Recursos">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="staff" 
                :fields="fields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaNacimiento)="data">
                {{ data.item.fechaNacimiento | fecha }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click.stop="editarItem(data.item)">
                    <i class="fa fa-edit"></i>Editar Datos del Staff</b-dropdown-item>
                </b-dropdown>
              </template>            
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Recurso</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'staff/getField',
  mutationType: 'staff/updateField',
});

export default {
  name: 'StaffList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      fields: [
        { 
          key: 'nombreCompleto',
          label: 'Nombre'
        },
        { 
          key: 'documentoNumero',
          label: 'Nro.Documento'
        },
        // { 
        //   key: 'fechaNacimiento',
        //   label: 'Fecha Nacim.'
        // },
        { 
          key: 'numeroCelular',
          label: 'Nro.Celular'
        },
        {
          key: 'email' 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1
    }
  },
  computed: {
    ...mapFields([
      'staff',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'documentoNumero',
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre.trim();
      this.documentoNumero = filtro.documentoNumero.trim();
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('staff/getStaff')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'StaffAdd' });
    },
    editarItem (item) {
      this.$router.push({ name: 'StaffEdit', 
                          params: { 
                            id: item.id 
                          }});
    },
    consultar (item) {
      this.$router.push({ name: 'StaffDatos', 
                          params: { 
                            id: item.id 
                          }});
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
